/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Option_100_TitleInputs */

const es_gift_option_100_title = /** @type {(inputs: Gift_Option_100_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patrón de Domingo`)
};

const gl_gift_option_100_title = /** @type {(inputs: Gift_Option_100_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patrón de Domingo`)
};

const en_gift_option_100_title = /** @type {(inputs: Gift_Option_100_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunday Skipper`)
};

/**
* | output |
* | --- |
* | "Sunday Skipper" |
*
* @param {Gift_Option_100_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_option_100_title = /** @type {((inputs?: Gift_Option_100_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Option_100_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_option_100_title(inputs)
	if (locale === "en") return en_gift_option_100_title(inputs)
	return es_gift_option_100_title(inputs)
});